import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import LogoBackground from "../images/logo-background.png";
import Phone from "../images/PhoneCall.png";
import Envelope from "../images/Envelope.png";
import MapPin from "../images/MapPin.png";
import x from "../images/XLogo.png";
import telegram from "../images/TelegramLogo.png";
import instagram from "../images/InstagramLogo.png";
import messenger from "../images/MessengerLogo.png";
import phone from "../images/PhoneCall.png";

const Contact = () => {
  return (
    <div>
      <Header />
      <div className="contact">
        <div className="box">
          <div className="contact-header">
            <h1>CONTACT</h1>
            <img alt="item's icon" src={LogoBackground} />
          </div>
          <div className="grid-2">
            <div className="column">
              <h3>Informații</h3>
              <p>
                <img alt="item's icon" src={Phone} />
                +40 722 333 444
              </p>
              <p>
                <img alt="item's icon" src={Envelope} />
                contact@aware.ro
              </p>
              <p>
                <img alt="item's icon" src={MapPin} />
                 Str. Exemplu 10, Constanta, România
              </p>
            </div>
            <div className="column">
              <h3>Program de lucru</h3>
              <p>Luni - Vineri: 09:00 - 18:00</p>
              <p>Sâmbătă: 10:00 - 14:00</p>
              <p>Duminică: Închis</p>
            </div>
            <div className="column center">
              <h3>Ne găsești și pe</h3>
              <div className="socials">
                <div className="social phone-number">
                  <a href="/" className="icon">
                    <img alt="header-icon" src={phone} />
                  </a>
                </div>
                <div className="social messenger">
                  <a href="/" className="icon">
                    <img alt="header-icon" src={messenger} />
                  </a>
                </div>
                <div className="social x">
                  <a href="/" className="icon">
                    <img alt="header-icon" src={x} />
                  </a>
                </div>
                <div className="social instagram">
                  <a href="/" className="icon">
                    <img alt="header-icon" src={instagram} />
                  </a>
                </div>

                <div className="social telegram">
                  <a href="/" className="icon">
                    <img alt="header-icon" src={telegram} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
